import type { ProjectId } from 'common/types'

import { getSurvey2dsByProjectIdApi } from '../../api'
import { addSurveyToProject } from '../project'
import type { AppThunk } from '../store'
import { survey2dSlice } from './survey2dSlice'

const { addSurvey2ds } = survey2dSlice.actions

export const getSurvey2dsByProjectId =
  (projectId: ProjectId): AppThunk =>
  dispatch => {
    getSurvey2dsByProjectIdApi(projectId)
      .then(survey2ds => {
        dispatch(addSurvey2ds(survey2ds))
        dispatch(addSurveyToProject(survey2ds))
      })
      .catch(console.error)
  }
